<div style="width: 0">
  <igx-dialog id="alert" #alert>
    <div class="header neo-dialog-shell-header">
      <div class="neo-dialog-header">
        <div class="neo-dialog-header__leading">
          <div class="neo-dialog-header__icon" [hidden]="!alertIcon || alertIcon.length === 0">
            <igx-icon>{{ alertIcon }}</igx-icon>
          </div>
          <div class="neo-dialog-header__title">{{ alertTitulo | translate }}</div>
        </div>
        <div class="neo-dialog-header__actions">
          <button title="{{ 'BOTONES.CERRAR' | translate }}" igxIconButton="flat" class="neo-dialog-header__button" (buttonClick)="cerrar()">
            <igx-icon>close</igx-icon>
          </button>
        </div>
      </div>
    </div>
    <div innerHTML="{{ alertMensaje | translate}}" class="tituloNotificaciones"></div>
    <div class="footer neo-dialog-footer">
      <div id="navBarFooter" class="neo-dialog-footer__actions">
        <button title="{{alerttextLeftButton | translate}}" igxButton="contained" (buttonClick)="cerrar()" [igxFocus]="true">
          <igx-icon>check</igx-icon>
          <span>{{alerttextLeftButton | translate}}</span>
        </button>
      </div>
    </div>
  </igx-dialog>
</div>
